module.exports = __webpack_public_path__ + "img/research_vision.8e8b3e84.svg";